import { Component, effect, inject, input, signal } from '@angular/core';
import { IconSvg } from '../icon-svg/icon-svg';
import { BreakpointObserver } from '@angular/cdk/layout';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { BurgerMenu } from '../burger-menu/burger-menu';

@Component({
  selector: 'app-title-section',
  imports: [BurgerMenu, IconSvg],
  templateUrl: './title-section.html',
  styleUrl: './title-section.css',
})
export class TitleSection {
  private breakpointObserver = inject(BreakpointObserver);

  title = input.required<string>();

  isNotificationHovered = signal(false);
  isMenuHovered = signal(false);
  isMenuDisplayed = signal(false);

  isTablet$ = toSignal(
    this.breakpointObserver
      .observe(['(min-width: 640px)'])
      .pipe(map(result => result.matches)),
    { initialValue: false }
  );

  constructor() {
    effect(() => {
      if (this.isTablet$() && this.isMenuDisplayed()) {
        this.isMenuDisplayed.set(false);
      }
    });
  }
}
